import {requestContext} from '../../../../common/requestContext';
import {SingleListViewItem} from '../../../../design-system/organisms/SingleListViewItem/SingleListViewItem';
import {SingleListViewItem as SingleListViewItemType} from '../../../../graphql/generated/types';
import {showImagePopup} from '../../../../imagePopup/imagePopupHandler';
import {checkWebAccessible} from '../../../content/[seriesId]/viewer/[productId]/util/checkWebAccessible';
import {CommonItemProps} from '../../type';

export function SingleListView({item}: CommonItemProps) {
  const {isMobile} = requestContext.requestInfo.display;
  return (
    <SingleListViewItem
      item={item as SingleListViewItemType}
      webAccessible={checkWebAccessible({
        isMobile,
        slideType: (item as SingleListViewItemType).single.slideType,
        isTextViewer: (item as SingleListViewItemType).single.operatorProperty
          ?.isTextViewer,
      })}
      onClickThumbnail={thumbnail => {
        showImagePopup({
          imageList: [thumbnail],
          isMobile,
          style: {cursor: 'pointer'},
        });
      }}
      isMobile={isMobile}
      imageLazyLoad={false}
    />
  );
}
